import { rem } from 'polished'
import React, { useState } from 'react'
import { type SpaceProps } from 'styled-system'
import { Flex } from 'components/Layout'
import { MarkdownRenderer } from 'components/MarkdownRenderer'
import { ReadMore } from 'components/ReadMore'
import { H4, Text } from 'components/Typography'
import { COLOR_INTENT, FONT_SIZE, SPACE } from 'Theme'
import { useMedia } from 'useMedia'

const EXPERT_BIO_READ_MORE_COLLAPSED_HEIGHT = {
  MOBILE: rem(70),
  DESKTOP: rem(95),
}

interface AboutSectionProps extends SpaceProps {
  description: string
}

export const AboutSection: React.FC<React.PWC<AboutSectionProps>> = ({
  description,
  ...rest
}) => {
  const [isDescriptionExpanded, setIsDescriptionExpanded] = useState(false)
  const { MOBILE: isMobile } = useMedia()
  return (
    <Flex
      flexDirection="column"
      mb={{ MOBILE: SPACE.PX_32, TABLET: SPACE.PX_40 }}
      {...rest}
    >
      <Flex width="100%" justifyContent="center">
        <H4 textAlign="center" mb={0}>
          About
        </H4>
      </Flex>
      <Flex mt={SPACE.PX_24}>
        {/* @ts-ignore - read more is not a TS file */}
        <ReadMore
          isExpanded={isDescriptionExpanded}
          collapsedHeight={
            isMobile
              ? EXPERT_BIO_READ_MORE_COLLAPSED_HEIGHT.MOBILE
              : EXPERT_BIO_READ_MORE_COLLAPSED_HEIGHT.DESKTOP
          }
          actionButton={() => (
            <Text
              as="button"
              color={COLOR_INTENT.BUTTON.TEXT_PRIMARY}
              onClick={() => {
                setIsDescriptionExpanded((prevState) => !prevState)
              }}
            >
              {isDescriptionExpanded ? 'Show less' : 'Read more'}
            </Text>
          )}
        >
          <MarkdownRenderer
            fontSize={FONT_SIZE.PX_16}
            markdownSource={description}
          />
        </ReadMore>
      </Flex>
    </Flex>
  )
}
